// Note: only #imports is a valid source here, otherwise the app will never finish loading!!!
import type { AppCountryConfig } from './index'
import { defineAppConfig } from '#imports'

export default defineAppConfig({
  countryConfig: {
    at: {
      emailBaseInfo: {
        label: 'heiland.com',
        value: 'mail@at.staging.heiland.com',
        replyLabel: 'heiland.com',
        replyValue: 'mail@at.staging.heiland.com',
        bcc: 'mail@at.staging.heiland.com',
        phone: '040 40 119 221',
      },
      defaultCustomerReference: 'Bitte_Heiland_melden',
      shopUrl: 'https://shop-staging.vetmazing.com/at',
    },
    de: {
      envOverwrites: {
        staging: {
          sns: {
            topics: {
              new_registration: 'arn:aws:sns:eu-central-1:177011103114:staging-euc1-infra-shared-webshop-new-registration-topic',
            },
          },
          shopUrl: 'https://shop-staging.heiland.com/de',
        },
      },
      emailBaseInfo: {
        label: 'heiland.com',
        value: 'mail@heiland.com',
        replyLabel: 'heiland.com',
        replyValue: 'mail@heiland.com',
        bcc: 'mail@heiland.com',
        phone: '040 40 119 221',
      },
      defaultCustomerReference: 'Bitte_Heiland_melden',
      sns: {
        topics: {
          new_registration: 'arn:aws:sns:eu-central-1:177011103114:prod-euc1-infra-shared-webshop-new-registration-topic',
        },
      },
      shopUrl: 'https://shop.heiland.com/de',
    },
    fr: {
      emailBaseInfo: {
        label: 'vetmazing.com',
        value: 'mail@vetmazing.com',
        replyLabel: 'vetmazing.com',
        replyValue: 'mail@vetmazing.com',
        bcc: 'mail@vetmazing.com',
        phone: '+33 646 806 913',
      },
      defaultCustomerReference: 'Bitte_Heiland_melden',
      sns: {
        topics: {
          new_registration: 'arn:aws:sns:eu-west-3:177011103114:prod-euw3-infra-shared-webshop-new-registration-topic',
        },
      },
      shopUrl: 'https://shop.vetmazing.com/fr',
    },
  } satisfies AppCountryConfig,
})
